module.exports = __webpack_public_path__ + "static/fonts/NeueAugenblick-Bold.df48be6f.woff";